import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'settings-menu-item.component',
  props: {
    title: null,
    active: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})